export const authFetch = (url, options = {}) => {
  const token = localStorage.getItem("authToken");
  const headers = {
    ...options.headers,
    Authorization: `Token ${token}`,
  };

  return fetch(url, {
    ...options,
    headers,
  });
};